import urlBuilder from '@sanity/image-url';

const sanityConfig = {projectId: '7nqypbju', dataset: 'production'}

const urlFor = source => urlBuilder(sanityConfig).image(source);

export default urlFor;